import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-arte-del-poeta',
  templateUrl: './arte-del-poeta.component.html',
  styleUrls: ['./arte-del-poeta.component.scss']
})
export class ArteDelPoetaComponent implements OnInit {

  slides = [
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004a.jpg", autor: "Calixto Pacheco Porras", anno: "1907" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004b.jpg", autor: "Calixto Pacheco Porras", anno: "1906" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004c.jpg", autor: "Calixto Pacheco Porras", anno: "1895" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004d.jpg", autor: "Daniel Alomía Robles", anno: "1920" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004e.jpg", autor: "Daniel Alomía Robles", anno: "1920" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004f.jpg", autor: "Marguerite Béclard D'Harcourt Khacampa", anno: "1923" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004g.jpg", autor: "Marguerite Béclard D'Harcourt Khacampa", anno: "1926" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004h.jpg", autor: "Marguerite Béclard D'Harcourt Khacampa", anno: "1923" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004i.jpg", autor: "Romualdo Alva Reyes", anno: "" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004j.jpg", autor: "Romualdo Alva Reyes", anno: "" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004k.jpg", autor: "Ernesto López Mindreau", anno: "1935" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004l.jpg", autor: "Pablo Chávez Aguilar ", anno: "1927" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004m.jpg", autor: "Retrato de Theodoro Valcárcel Caballero", anno: "1913" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004n.jpg", autor: "Theodoro Valcárcel Caballero", anno: "1930" },


  ];

  slides2 = [
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img005a.jpg", autor: "Manuel Lorenzo Aguirre de la Fuente", anno: "1924" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img005b.jpg", autor: "Manuel Lorenzo Aguirre de la Fuente", anno: "1924" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img005c.jpg", autor: "Luis Duncker Lavalle", anno: "1920" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img005d.jpg", autor: "Luis Duncker Lavalle", anno: "1920" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img005e.jpg", autor: "Benigno Ballón Farfán", anno: "1920" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img005f.jpg", autor: "Benigno Ballón Farfán", anno: "1920" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img005g.jpg", autor: "Roberto Carpio Valdés", anno: "1939" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img005h.jpg", autor: "Carlos Sánchez Málaga", anno: "1950" },
  ];

  slides3 = [
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img006a.jpg", autor: "Retrato de Francisco González Gamarra", anno: "1930" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img006b.jpg", autor: "Francisco González Gamarra", anno: "1935" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img006c.jpg", autor: "Francisco González Gamarra", anno: "1914" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img006d.jpg", autor: "Roberto Ojeda Campana", anno: "1927" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img006e.jpg", autor: "Armando Guevara Ochoa", anno: "1940" },
    { img: "/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img006f.jpg", autor: "Armando Guevara Ochoa", anno: "1940" },

  ];


  slideConfig = {
    "slidesToShow": 5, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 600,
        'settings': {
          'slidesToShow': 1
        }
      }


    ]
  };

  constructor(private titleService: Title) {
    this.titleService.setTitle("EL ARTE DEL POETA JOSÉ MARÍA EGUREN");
  }

  ngOnInit(): void {
  }

}
